/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { defineMessages } from 'react-intl';

const paymentMethods = defineMessages({
  revmedCredit: {
    id: 'InvoiceDetailsModal.paymentMethod.revmedCredit',
    defaultMessage: 'RevMed Credit Applied'
  },
  invoicePaid: {
    id: 'InvoiceDetailsModal.paymentMethod.invoicePaid',
    defaultMessage: 'Invoice Paid'
  },
  wire: {
    id: 'InvoiceDetailsModal.paymentMethod.wire',
    defaultMessage: 'Wire Transfer'
  },
  ach: {
    id: 'InvoiceDetailsModal.paymentMethod.ach',
    defaultMessage: 'ACH Payment'
  },
  check: {
    id: 'InvoiceDetailsModal.paymentMethod.check',
    defaultMessage: 'Check Payment'
  },
  other: {
    id: 'InvoiceDetailsModal.paymentMethod.other',
    defaultMessage: 'Other'
  }
});

export default { paymentMethods };
